
export enum NHSGrade {
  FY1 = 'Foundation Year 1 (FY1)',
  FY2 = 'Foundation Year 2 (FY2)',
  CT = 'Core Trainee (CT1-CT3)',
  ST1_2 = 'Specialty Trainee (ST1-ST2)',
  ST3_PLUS = 'Specialty Trainee (ST3-ST8 / Registrar)',
  TrustGrade = 'Trust Grade / SHO',
  ClinicalFellowJunior = 'Junior Clinical Fellow',
  ClinicalFellowSenior = 'Senior Clinical Fellow / Registrar level',
  SpecialtyDoctor = 'Specialty Doctor (SAS)',
  AssociateSpecialist = 'Associate Specialist',
  Consultant = 'Consultant',
  GPSalaried = 'Salaried GP',
  GPPartner = 'GP Partner',
  GPTrainee = 'GP Trainee'
}

export enum InterviewType {
  Clinical = 'Clinical',
  Portfolio = 'Portfolio-Competency',
  Leadership = 'Leadership',
  Ethics = 'Ethics-Governance',
  Specialty = 'Specialty-Specific',
  Mixed = 'Mixed'
}

export interface User {
  id: string;
  fullName: string;
  email: string;
  password?: string;
  isPremium?: boolean;
  credits?: number; 
}

export interface UserFeedback {
  id?: string;
  userId: string;
  userName: string;
  userEmail: string;
  category: 'Suggestion' | 'Bug' | 'Content Request' | 'Other';
  content: string;
  createdAt: string;
}

export interface StructuredRequirement {
  roleTitle: string;
  trustName: string;
  grade: string;
  responsibilities: string[];
  essentialCriteria: string[];
  desirableCriteria: string[];
  competencies: string[];
  keywords: string[];
}

export interface Question {
  id: string;
  text: string;
  domainTags: string[];
  difficulty: 'Easy' | 'Medium' | 'Hard';
  interviewerFocus: string;
  pitfalls: string[];
  isPinned?: boolean;
  modelAnswer: {
    points: string[];
    structure: string;
  };
  rubric: {
    category: string;
    description: string;
    maxScore: number;
  }[];
}

export interface Feedback {
  scores: Record<string, number>;
  overallScore: number;
  pros: string[];
  cons: string[];
  blindSpots: string[];
  suggestedAnswer: string;
  hurdleFeedback: string; 
  hurdlePros?: string[];
  hurdleCons?: string[];
  hurdleIdealAnswer?: string;
  drills: string[];
  frameworkUsed: 'STAR' | 'CAMP' | 'SPIES' | 'CARE' | 'Ethics' | 'Unknown';
}

export interface AnswerAttempt {
  questionId: string;
  answerText: string;
  followUpThread: { q: string; a: string }[];
  feedback?: Feedback;
  timestamp: string;
}

export interface Session {
  id: string;
  userId: string;
  journeyId: string;
  startTime: string;
  endTime?: string;
  attempts: AnswerAttempt[];
  overallSummary?: string;
  isComplete?: boolean;
  currentQuestionIdx?: number;
  activeFollowUp?: string | null;
  isPublic?: boolean;
}

export interface StrategicAdvice {
  title: string;
  advice: string;
}

export interface StrategicPlan {
  userId: string;
  updatedAt: string;
  items: StrategicAdvice[];
}

export interface JourneyAnswerSet {
  id?: string;
  userId: string;
  journeyId: string;
  answers: Record<string, string>;
  createdAt?: string;
}

export interface VoiceSettings {
  voiceName?: string;
  rate?: number;
  pitch?: number;
}

export interface Journey {
  id: string;
  userId: string;
  title: string;
  grade: NHSGrade;
  specialty: string;
  interviewType: InterviewType;
  isRealInterview?: boolean;
  voiceSettings?: VoiceSettings;
  additionalDocs?: KnowledgeDoc[];
  difficulty: 'Novice' | 'Intermediate' | 'Expert';
  requirements?: StructuredRequirement;
  questions: Question[];
  candidateProfile?: string;
  createdAt: string;
  isPublic?: boolean;
}

export interface KnowledgeDoc {
  id: string;
  userId: string;
  title: string;
  content?: string;
  fileData?: string;
  fileUrl?: string;
  mimeType?: string;
  tags: string[];
  isSystem?: boolean;
}
